module.exports = __webpack_public_path__ + "img/sx.sxc3e3382.svg";